import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  isMobileDevice,
  updatePhoneNum,
  updateorderId,
  safeUpperCase,
  getAndCheck,
  getAddHopeItem,
  getValueOrEmptyString,
  getCarryBagItem,
  getTernaryValue,
  phoneNumber_Check,
  DeliveryAddresslines,
  getEmbeddedErrorMessageAnalytic,
} from 'common/utilities/utils';
import { getUnixTimeInSeconds, formatDateTime } from 'common/utilities/dayJsUtils';
import Modal from '../../../molecules/Modal';
import { ButtonComp } from '../../../atoms/Buttons';
import { getPastOrderAction, clearPastOrderAction } from '@kfc-global/react-shared/redux/Actions/orderAction';
import phoneImg from '../../../styles/staticAssets/images/Call.svg';
import Direction from '../../../styles/staticAssets/images/Direction.svg';
import LookUpMap from './LookupMap';
import FOOTER_CONSTANT from '../FooterConstants/FooterConstant';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { MaterialTextInput } from 'atoms/MaterialInput';
import { getTendersContent } from '@kfc-global/react-shared/redux/Actions/PaymentsContentAction';
import { getCmsClient } from 'common/utilities/cmsClient';
import { displayPrice } from 'components/checkout/PriceSummary';
import { accordianData } from '../../PaymentProcess/Presentation/orderReceivedScreenFn';

export const isValidEmail = email => {
  var pattern = FOOTER_CONSTANT.EMAIL_REGEX;
  return pattern.test(email);
};

let AnalyticEmailValidationCounter = 0;
export const updateUserEmail = (userEmail, inputValue, setEnableButton) => {
  let emailObj = { ...userEmail };
  let errormsg = emailObj.errorMessage;
  emailObj.value = inputValue;
  if (!inputValue) {
    emailObj.error = true;
    emailObj.errorMessage = translateWithI18Next('yourEmailHelpText');
    setEnableButton(true);
  } else if (!isValidEmail(inputValue)) {
    emailObj.error = true;
    emailObj.errorMessage = translateWithI18Next('invalidYourEmailErrText');
    setEnableButton(true);
  } else {
    AnalyticEmailValidationCounter = 0;
    emailObj.error = false;
    emailObj.errorMessage = '';
  }
  if (errormsg !== emailObj.errorMessage) {
    AnalyticEmailValidationCounter = 0;
  }
  if (emailObj.error && AnalyticEmailValidationCounter === 0) {
    AnalyticEmailValidationCounter = 1;
    getEmbeddedErrorMessageAnalytic('OrderLookup', emailObj.errorMessage);
  }
  return emailObj;
};

const getFilteredItems = (foodLineItems, addHope, carryBag) => {
  return foodLineItems.filter(foodItem => foodItem?.item?.name !== addHope && foodItem.item?.name !== carryBag);
};
const setAddHopeCarryBagInfo = (
  lookUpData,
  addHope,
  carryBag,
  SEARCH_IN_CART,
  setAddHopeObj,
  setCarryBagObj,
  tenantReducer,
) => {
  const { setAddHopeDataExistsId, setAddHopeDataPrice } = setAddHopeObj;
  const { setCarryBagDataExistsId, setCarryBagDataPrice } = setCarryBagObj;
  const { currencyConversionFactor } = tenantReducer;
  let addHopeDataExists = lookUpData.foodLines.length
    ? getAddHopeItem(lookUpData.foodLines, addHope, currencyConversionFactor, SEARCH_IN_CART)
    : {};
  let addHopeId = getValueOrEmptyString(addHopeDataExists?.id);
  setAddHopeDataExistsId(addHopeId);
  if (addHopeId) {
    let lineItem = lookUpData.foodLines.find(i => i.id === addHopeId);
    setAddHopeDataPrice(displayPrice(lineItem.amount, tenantReducer));
  }

  let carryBagDataExists = lookUpData.foodLines.length
    ? getCarryBagItem(lookUpData.foodLines, carryBag, currencyConversionFactor, SEARCH_IN_CART)
    : {};
  let addCBId = getValueOrEmptyString(carryBagDataExists?.id);
  setCarryBagDataExistsId(addCBId);
  if (addCBId) {
    let lineItem = lookUpData.foodLines.find(i => i.id === addCBId);
    setCarryBagDataPrice(displayPrice(lineItem.amount, tenantReducer));
  }
};
const Discounts = (lookUpData, currencySymbol, discountTotal, DISCOUNT) => {
  return (
    lookUpData?.discountLines?.length > 0 && (
      <div className='priceList'>
        <span className='fonts'>
          {translateWithI18Next(DISCOUNT)} ({lookUpData?.discountLines[0]?.couponCode})
        </span>
        <span className='amount'>
          {' '}
          - {currencySymbol}
          {discountTotal}
        </span>
      </div>
    )
  );
};
export const ModalLookUpComponent = props => {
  const { isOpen = false, handleClose } = props;
  const dispatch = useDispatch();
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { tenantId, currencySymbol, currencyConversionFactor, addHope, carryBag } = tenantReducer;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const [date, setDate] = useState('');
  const [subTotal, setSubtotal] = useState(0);
  const [TaxVal, setTaxVal] = useState([]);
  const [AdditionalCharges, setadditionalCharges] = useState([]);
  const [discountTotal, setDiscountTotal] = useState(0);
  const [total, setTotal] = useState('');
  const [time, setTime] = useState('');
  const [SubmitErrorMessage, setErrorMessage] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [OrderDetails, setOrderDetails] = useState(false);
  const [paymentType, setPaymentType] = useState({});
  const [enableButton, setEnableButton] = useState(true);
  const [service, setService] = useState('');
  const [carryBagDataExistsId, setCarryBagDataExistsId] = useState('');
  const [addHopeDataExistsId, setAddHopeDataExistsId] = useState('');
  const [addHopeDataPrice, setAddHopeDataPrice] = useState(0);
  const [carryBagDataPrice, setCarryBagDataPrice] = useState(0);
  const [Item, setItemData] = useState([]);
  const [userEmail, setUserEmail] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });
  const [userPhone, setUserPhone] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });
  const [orderNumber, setorderNumber] = useState({
    value: '',
    errorMessage: '',
    error: false,
  });
  const {
    PHONE_NUM,
    ORDER_NUMBER,
    CANCEL,
    SUBMIT,
    ORDERHASH,
    YOUR_ORDER,
    DELIVER_TO,
    ORDER_FROM,
    GET_DIRECTION,
    DISCOUNT,
    TOTAL,
    COMPLETED,
    SUB_TOTAL,
    PAYMENT,
    ORDER_LOOKUP,
    EMAIL_ADDRESS,
    DELIVERY,
    SEARCH_IN_CART,
    largeCarryBagText,
    addHopeText,
  } = FOOTER_CONSTANT;

  useEffect(() => {
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
  }, [isMobile]);

  const windowResized = () => {
    setIsMobile(isMobileDevice(window.innerWidth));
  };

  useEffect(() => {
    dispatch(
      getTendersContent({
        object: getCmsClient(),
        contentFull: {
          content_type: 'tenders',
          include: 5,
          select: 'sys.id,fields',
        },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
   // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (
      userEmail.value !== '' &&
      !userEmail.error &&
      userPhone.value !== '' &&
      !userPhone.error &&
      orderNumber.value !== '' &&
      !orderNumber.error
    ) {
      setEnableButton(false);
    }
  });
  useEffect(() => {
    if (orderNumber.value.trim() === '') {
      setEnableButton(true);
    }
  }, [orderNumber?.value]);
  const { tendersContent } = useSelector(data => data.paymentsContentReducer);
  const { items } = tendersContent;

  const currencyConversion = amount => {
    return(
      (amount / currencyConversionFactor).toFixed(2)
    )
  };
  useEffect(() => {
    return dispatch(
      clearPastOrderAction({
        emailId: userEmail.value,
        phoneNo: userPhone.value,
        orderNo: orderNumber.value,
      }),
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const OrderData = useSelector(data => data.orderReducer);
  const { pastOrderResponse = [{}] } = OrderData;
  const lookUpData = pastOrderResponse[0];
  useEffect(() => {
    if (getAndCheck(items?.length, lookUpData?.paymentReferences)) {
      items.forEach(data => {
        if (data.fields.title === lookUpData.paymentReferences[0].paymentType) {
          setPaymentType(data);
        }
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookUpData]);
  useEffect(() => {
    if (lookUpData?.id) {
      setErrorMessage(false);
      setOrderDetails(true);
      const val = lookUpData.fulfillmentDateTime;
      const dateorder = formatDateTime(getUnixTimeInSeconds(val), 'll');
      const Time = formatDateTime(getUnixTimeInSeconds(val), 'h:mm A');
      setDate(dateorder + ' at ' + Time);
      setTaxVal(lookUpData.taxLines);
      setadditionalCharges(lookUpData.additionalChargeLines);
      setDiscountTotal(currencyConversion(lookUpData.discountTotal));
      setTime(PhoneNum(lookUpData.store.phoneNumber));
      setSubtotal(currencyConversion(lookUpData.subTotal));
      setTotal(currencyConversion(lookUpData.total));
      setService(lookUpData.service);
      let addHopeCarryBag = getAndCheck(addHope, carryBag);
      if (addHopeCarryBag) {
        let setAddHopeObj = { setAddHopeDataExistsId, setAddHopeDataPrice };
        let setCarryBagObj = { setCarryBagDataExistsId, setCarryBagDataPrice };
        setAddHopeCarryBagInfo(
          lookUpData,
          addHope,
          carryBag,
          SEARCH_IN_CART,
          setAddHopeObj,
          setCarryBagObj,
          tenantReducer,
        );
        let filteredItems = getFilteredItems(lookUpData.foodLines, addHope, carryBag);
        setItemData(filteredItems);
      }
    } else if (!lookUpData) {
      setOrderDetails(false);
      setErrorMessage(true);
      getEmbeddedErrorMessageAnalytic('OrderLookup', translateWithI18Next('invaidInputs'));
      setEnableButton(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pastOrderResponse]);

  const modalProps = isMobile
    ? {
        id: 'OrderlookUpPopup',
        role: 'dialog',
        modalTitleId: 'OrderlookUpPopup',
        show: isOpen,
        classNames: getTernaryValue(OrderDetails, 'lookup-order-modal', 'Base-modal'),
        showCloseBtn: true,
        closeButtonHandler: handleClose,
        autoFocus: true,
        modalTitle: translateWithI18Next(ORDER_LOOKUP),
        closeDataTestId: 'close-quick-reorder-modal',
      }
    : {
        id: 'OrderlookUpPopup',
        role: 'dialog',
        modalTitleId: 'OrderlookUpPopup',
        show: isOpen,
        classNames: getTernaryValue(OrderDetails, 'lookup-order-modal', 'Base-modal'),
        showCloseBtn: true,
        showBackBtn: false,
        closeButtonHandler: handleClose,
        modalTitle: 'ORDER LOOKUP',
        autoFocus: true,
        closeDataTestId: 'close-quick-reorder-modal',
      };

  function PhoneNum(num) {
    num.substr(0, num.indexOf(' '));
    const Contactnumber = num.substr(num.indexOf(' ') + 1);
    return(
      Contactnumber.slice(0, 3) + '-' + Contactnumber.slice(3, 6) + '-' + Contactnumber.slice(6)
    )
  }

  const updateFormDetails = (e, select) => {
    setErrorMessage(false);
    let inputValue = e.target.value;
    let check = phoneNumber_Check(inputValue, select);
    if (check) {
      let value = inputValue.replace(/\+|-/gi, '');
      setUserPhone({
        ...updatePhoneNum(userPhone, value, setEnableButton),
      });
    }
    if (select === EMAIL_ADDRESS) {
      setUserEmail({
        ...updateUserEmail(userEmail, inputValue, setEnableButton),
      });
    }
    if (select === ORDER_NUMBER) {
      setorderNumber({
        ...updateorderId(orderNumber, inputValue, setEnableButton),
      });
    }
  };
  const bill = (
    <div className='priceList'>
      <span className='fonts'>GST</span>
      <span className='amount'>
        {currencySymbol}
        {currencyConversion(lookUpData?.inclusiveTaxTotal)}{' '}
      </span>
    </div>
  );

  const Added_Charges = AdditionalCharges.map(function (data, idx) {
    return (
      <div key={idx} className='priceList'>
        <span className='fonts'> {data.chargeType}</span>
        <span className='amount'>
          {currencySymbol}
          {currencyConversion.call(this, data.amount)}{' '}
        </span>
      </div>
    );
  });

  const InputBox = (
    <div>
      <div className='InputArea'>
        <h3 className='InputHeading'>Enter your order Number</h3>
        <div className='inputLookUpNumbox'>
          {!isMobile && <p className='lookup-mandatory-note'>{translateWithI18Next('mandatorynote')}</p>}
          <MaterialTextInput
            data-testid='user-phoneNum'
            type='number'
            autoComplete='on'
            value={userPhone.value}
            labelClassName='info-labelData'
            inputClassName='info-inputData'
            helperTextClassName='error-text'
            placeholder={translateWithI18Next(PHONE_NUM)}
            onChange={e => updateFormDetails(e, PHONE_NUM)}
            helperText={userPhone.errorMessage}
            error={userPhone.error}
          />
          <MaterialTextInput
            data-testid='user-orderId'
            autoComplete='off'
            value={orderNumber.value}
            labelClassName='info-labelData'
            inputClassName='info-inputData'
            helperTextClassName='error-text'
            placeholder={translateWithI18Next(ORDER_NUMBER)}
            onChange={e => updateFormDetails(e, ORDER_NUMBER)}
            helperText={orderNumber.errorMessage}
            error={orderNumber.error}
          />
          <MaterialTextInput
            data-testid='user-email'
            autoComplete='on'
            value={userEmail.value}
            labelClassName='info-labelData'
            inputClassName='info-inputData'
            helperTextClassName='error-text'
            placeholder={translateWithI18Next(EMAIL_ADDRESS)}
            onChange={e => updateFormDetails(e, EMAIL_ADDRESS)}
            helperText={userEmail.errorMessage}
            error={userEmail.error}
          />
        </div>
        {SubmitErrorMessage && (
          <div>
            <span className='exMark'>!</span>
            <span className='errorMessage'>{translateWithI18Next('invaidInputs')}</span>
          </div>
        )}
      </div>
      <div className='buttonItems'>
        <ButtonComp
          data-testid='cancel-button'
          ariaLable='cancel'
          className='button whiteButton blackBorder closebtn-cls'
          onClick={e => oncancel()}
        >
          {CANCEL}
        </ButtonComp>
        <ButtonComp
          data-testid='submit-button'
          ariaLable='submit'
          className='button blackButton blackBorder save-button'
          onClick={e => submitHandler(e)}
          disabled={enableButton}
        >
          {SUBMIT}
        </ButtonComp>
      </div>
    </div>
  );
  const submitHandler = e => {
    if (getAndCheck(userEmail.value, getAndCheck(userPhone.value, orderNumber.value)) !== '') {
      dispatch(
        getPastOrderAction({
          emailId: userEmail.value,
          phoneNo: userPhone.value,
          orderNo: orderNumber.value,
          tenantId: tenantId,
        }),
      );
    }
  };

  const oncancel = () => {
    setOrderDetails(false);
    handleClose();
    dispatch(
      clearPastOrderAction({
        emailId: userEmail.value,
        phoneNo: userPhone.value,
        orderNo: orderNumber.value,
      }),
    );
  };
  const onClickBack = () => {
    setOrderDetails(false);
  };
  const GetDirectionClick = () => {
    setShowMap(true);
  };
  let contactNumb = lookUpData?.store?.phoneNumber;
  const callNum = 'tel:' + contactNumb;
  return (
    <div>
      {isOpen && !OrderDetails && (
        <Modal {...modalProps}>
          <div className='LookUpmodalContants'>{InputBox}</div>
        </Modal>
      )}
      {isOpen && OrderDetails && lookUpData && (
        <Modal {...modalProps}>
          <div className='LookUpmodalContants'>
            <>
              <div className='orderLookUpData'>
                <div className='Orderheading'>
                  <span className='yourOrder'>{YOUR_ORDER}</span>
                  <span className='idNumber'>
                    {ORDERHASH}
                    {lookUpData.posOrderId}
                  </span>
                </div>
                <div className='CompletedDateAndTime'>
                  <span className='completed'>{COMPLETED}</span>
                  <span className='dateCompleted'>{date}</span>
                </div>
                {safeUpperCase(lookUpData?.service) === DELIVERY && lookUpData?.deliveryAddress !== null && (
                  <div className='CompletedDateAndTime'>
                    <span className='completed'>{DELIVER_TO}</span>
                    <span className='dateCompleted'>{DeliveryAddresslines(lookUpData?.deliveryAddress)}</span>
                  </div>
                )}
                <div className='CompletedDateAndTime'>
                  <span className='completed'>{PAYMENT}</span>
                  <span className='dateCompleted'>
                    {paymentType.fields.displayFormat === 'Only image' ? (
                      <img src={paymentType.fields.icon.fields.desktopImage.fields.file.url} alt='paymentMethod' />
                    ) : (
                      <span className='dateCompleted'>{paymentType.fields.displayName}</span>
                    )}
                  </span>
                </div>
                <div className='CompletedDateAndTime'>
                  <span className='completed'> {ORDER_FROM}</span>
                  {lookUpData.store !== null && lookUpData.store !== undefined && (
                    <span className='dateCompleted'>
                      {lookUpData.store.name}
                      <br />
                      {lookUpData?.store?.address?.addressLines}
                    </span>
                  )}
                </div>
                <div className='CompletedCallAndDirection' id='DirectionTest'>
                  <span> </span>
                  <span className='callAndDirection'>
                    <span className='KfcphoneNums'>
                      <img src={phoneImg} alt='phone' className='KfcphoneIcon' />
                      <a href={callNum} className='anchorTags'>
                        {time}
                      </a>
                    </span>

                    <span className='KfcphoneNums' id='DirectionClick' onClick={GetDirectionClick}>
                      <img src={Direction} alt='phone' className='KfcDirectionIcon' />
                      {translateWithI18Next(GET_DIRECTION)}
                    </span>
                  </span>
                </div>
                <div className='detailsAccordian'>{accordianData(Item, currencySymbol, currencyConversionFactor)}</div>
                <div className='price'>
                  <span className='fonts'>{translateWithI18Next(SUB_TOTAL)}</span>
                  <span className='amount'>
                    {currencySymbol}
                    {subTotal}
                  </span>
                </div>
                {TaxVal && <div>{bill}</div>}
                {AdditionalCharges && <div>{Added_Charges}</div>}
                {Discounts(lookUpData, currencySymbol, discountTotal, DISCOUNT)}
                {service.toUpperCase() === 'PICKUP' && carryBagDataExistsId && (
                  <div className='priceList' id='priceListData'>
                    <span className='fonts' id='fontStyle'>
                      {translateWithI18Next(largeCarryBagText)}
                    </span>
                    <span className='amount' id='amountStyle'>
                      {carryBagDataPrice}
                    </span>
                  </div>
                )}
                {Boolean(addHopeDataExistsId) && (
                  <div className='priceList' id='priceListData'>
                    <span className='fonts' id='fontStyle'>
                      {translateWithI18Next(addHopeText)}
                    </span>
                    <span className='amount' id='amountStyle'>
                      {addHopeDataPrice}
                    </span>
                  </div>
                )}
                {total && (
                  <div className='totalAmount'>
                    <span className='total'>{TOTAL}</span>
                    <span className='total'>
                      {currencySymbol}
                      {total}
                    </span>
                  </div>
                )}
              </div>
              <div className='buttonItemsDone'>
                <ButtonComp
                  data-testid='cancel-button'
                  className='button whiteButton blackBorder closebtn-cls'
                  id='lookupButton'
                  onClick={e => onClickBack()}
                >
                  {translateWithI18Next('backButton')}
                </ButtonComp>
                <ButtonComp
                  data-testid='submit-button'
                  className='button blackButton blackBorder save-button'
                  onClick={e => oncancel()}
                >
                  {translateWithI18Next('popoverDoneButton')}
                </ButtonComp>
              </div>
            </>
          </div>
        </Modal>
      )}
      {showMap && (
        <div>
          <LookUpMap
            data-testid='map-modal'
            isOpen={showMap}
            handleClose={() => setShowMap(false)}
            OrderReducerData={lookUpData}
          />
        </div>
      )}
    </div>
  );
};

export default ModalLookUpComponent;
